/**
 * Seller Watch API client. Only addSeller may trigger a Walmart catalog fetch
 * (server-side, after the duplicate/limit checks); every other call is storage-only.
 */
import { del, get, patch, post } from "@/lib/api";

const BASE = "/storefront-hunter/watch";
const sellerPath = (id) => `${BASE}/${encodeURIComponent(id)}`;

export const fetchSellerWatch = () => get(BASE);

/** Recently observed sellers (aggregate, no user attribution). Mongo-only. */
export const fetchRecentSellers = () => get("/storefront-hunter/recent-sellers");

export const resolveWatchSeller = (seller) =>
  get(`${BASE}/resolve?${new URLSearchParams({ seller }).toString()}`);

export const addWatchSeller = (seller) => post(BASE, { seller }, { timeout: 60000 });

export const updateWatchSeller = (id, body) => patch(sellerPath(id), body);

export const markWatchSellerRead = (id) => post(`${sellerPath(id)}/read`, {});

export const removeWatchSeller = (id) => del(sellerPath(id));
